
import React from 'react';
import { Button } from '../../../components/base/Button';

export const WeBuyHero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/3de0008ff1bd7c4829ac2d9a6c602126.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-32 text-center text-white">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          We Buy Apartment Buildings
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-gray-100 max-w-3xl mx-auto">
          Fast, Fair Cash Offers for Your Multi-Family Property. No Repairs, No Fees, No Hassle.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button variant="primary" size="lg" href="https://sellapartmentscash.com#get-offer">
            Get Your Cash Offer Now
          </Button>
          <Button variant="ghost" size="lg" href="#process-steps">
            See How It Works
          </Button>
        </div>
      </div>
    </section>
  );
};
